/**
 * storage-status.service.ts — estado del storage provider (Cloudinary/R2).
 * Consumido por AdminLayout para el banner panel-wide cuando el storage está degradado.
 */
import { httpGet } from "@/shared/lib/http-client.js";

export async function getStorageStatus(): Promise<{ degraded: boolean; updatedAt: string }> {
  return httpGet<{ degraded: boolean; updatedAt: string }>("/storage/status");
}
